import React, { Component } from 'react';
import { connect } from 'react-redux';
import {lowestDenom} from '../../../../config';
import TakeOrders from './takingOrders0';

class TakingOrders extends Component {
  constructor(){
    super();
    this.state = {amount:0,to:0,name:"BTC"};
  }
  render() {
    var items = this.props.takeOrders.map(({receivesToChain,sendsFromChain,amount,price,type,id,cml,takeAmount,nrgUnit,collateralizedNrg,blockHeight,depositLeft,settleLeft},i) => {
      if(takeAmount ===  null || takeAmount == 0) takeAmount = amount;
      let modifiedCollateral = collateralizedNrg * takeAmount / amount;
      return (
        <tr style={{cursor:'pointer'}}>
          <td>Taker</td>
          <td>{takeAmount} {receivesToChain.toUpperCase()}</td>
          <td>{takeAmount*price} {sendsFromChain.toUpperCase()}</td>
          <td>{modifiedCollateral} NRG</td>
          <td>{settleLeft}</td>
        </tr>
      );
    });

    if(this.props.makerAmount && this.props.price != 0){
      items.unshift((
        <tr style={{cursor:'pointer'}} key={`${this.props.makerAmount}-${this.props.price}`}>
          <td>Maker</td>
          <td>{this.props.sendsUnit} {this.props.sendsFromChain.toUpperCase()}</td>
          <td>{this.props.receivesUnit} {this.props.receivesToChain.toUpperCase()}</td>
          <td>{this.props.makerCollateral} NRG</td>
          <td>in {this.props.settlement} Blocks</td>
        </tr>
      ))
    }

    return (
      <div className="" style={{maxHeight:'300px',overflowY:'scroll'}}>
        {/*<img src={`/trade.png`} style={{height:'50px',float:'left'}} /> */}
        <h4 className="black-text" style={{marginTop: '5px',display:'inline-block'}}> Trade Confirmation</h4>

        <span className='confirmationCurrencies'>
          <img src={`/${this.props.receivesToChain}.png`} style={{height:'30px',float:'right'}} />
          <i className="material-icons" style={{"color": "black",float: "right",fontSize: "1.5em",marginRight:'5px',lineHeight:'30px'}}>arrow_forward</i>
          <img src={`/${this.props.sendsFromChain}.png`} style={{height:'30px',float:'right',marginRight:'5px'}} />
        </span>

        <TakeOrders/>
      </div>
		)
  }
}

function mapStateToProps(state,props) {

  let {denomination,asset,type} = state.ui_marketplace.market;
  let sendsFromChain = state.ui_marketplace.orderType === 'BUY' ? denomination : asset;
  let receivesToChain = state.ui_marketplace.orderType === 'BUY' ? asset : denomination;
  let receivesUnit = state.ui_marketplace.orderType == 'BUY' ? state.ui_marketplace.makerAmount : state.ui_marketplace.makerAmount*state.ui_marketplace.price
  let sendsUnit = state.ui_marketplace.orderType == 'SELL' ? state.ui_marketplace.makerAmount : state.ui_marketplace.makerAmount*state.ui_marketplace.price

  return {
    market: state.ui_marketplace.market,
    orderType: state.ui_marketplace.orderType,
    price: state.ui_marketplace.price,
    makerAmount: state.ui_marketplace.makerAmount,
    settlement:state.settings.settings.settlement,
    receivesUnit,
    sendsUnit,
    sendsFromChain,
    receivesToChain,
    makerCollateral: state.ui_marketplace.makerCollateral,
    takeOrders: state.ui_marketplace.takeOrders
  };
}

export default connect(mapStateToProps, {})(TakingOrders);
